import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, WifiOff } from "lucide-react";

export const Header = ({ title, subtitle, back = true, right = null, badge = true }) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-start justify-between mb-6 fade-slide-up" data-testid="page-header">
      <div className="flex items-start gap-3">
        {back && (
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 rounded-full flex items-center justify-center border gold-border hover:bg-[rgba(230,180,85,0.08)] transition"
            data-testid="header-back-btn"
            aria-label="Back"
          >
            <ArrowLeft size={18} className="text-[#F7E6B4]" />
          </button>
        )}
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#F7E6B4]" data-testid="page-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-[#F7E6B4]/55 mt-1" data-testid="page-subtitle">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {right}
        {badge && (
        <div className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border gold-border bg-[rgba(230,180,85,0.06)]" data-testid="offline-badge">
          <WifiOff size={12} className="text-[#E6B455]" />
          <span className="text-[10px] uppercase tracking-wider text-[#E6B455] font-medium">Offline</span>
        </div>
        )}
      </div>
    </div>
  );
};
